<ion-app>
  <ion-menu contentId="myMenuContent" id="myMenu" (ionWillOpen)="validateChatIsOpen()" [swipeGesture]="false"
    [disabled]="isLoginRoute()">
    <csi-mobilemenu (sendNav)="onTypeEmitted($event)" [activeMenuItem]="activeMenuItem" [civarMenu]="civarMenu"
      [quantumCivarMenu]="quantumCivarMenu"></csi-mobilemenu>
  </ion-menu>

  @if (isAuth && !isLoginRoute()) {
  <csi-menu-lat (sendNav)="onTypeEmitted($event)" [activeMenuItem]="activeMenuItem" [civarMenu]="civarMenu" [quantumCivarMenu]="quantumCivarMenu"
    [hidden]="!showMenuLatDesktop || useMobileNav()"></csi-menu-lat>
  }

  <ion-router-outlet id="myMenuContent" [hidden]="!isOutSplashScreen">
  </ion-router-outlet>

  @if (isAuth && !isLoginRoute()) {
  <chat-ai-popup [quantronAccessInfo]="chatQuantronAccessInfo" [hidden]="!showChatAIPopup"></chat-ai-popup>
  }
</ion-app>